// pages/HomePage.js
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) =>
    theme.backgroundGradient || 'linear-gradient(135deg, #2cc2d4, #007bff)'};
  padding: 20px;
`;

const Card = styled.div`
  background-color: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: ${({ theme }) => theme.text || '#333'};
  margin-bottom: 20px;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.subtext || '#555'};
  margin-bottom: 30px;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.primary || '#2cc2d4'};
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover || '#27a4ad'};
  }
`;

function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated, authChecked } = useAuth();

  useEffect(() => {
    if (!authChecked) return;
    if (isAuthenticated) navigate('/post-login');
  }, [isAuthenticated, authChecked, navigate]);

  return (
    <Container>
      <Card>
        <Title>Welcome to TranquilBlogger</Title>
        <Subtitle>A private platform for multi-blog travel journaling.</Subtitle>

        <Button onClick={() => navigate('/login')}>Login</Button>
      </Card>
    </Container>
  );
}

export default HomePage;
